import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import addAction from './add-action.vue';
import { handlerBranch, showData } from '../util';
export default {
  name: 'Branch',
  components: {
    addAction: addAction
  },
  props: {
    sourceData: {
      type: Object,
      default: function _default() {
        return [];
      }
    },
    del: {
      type: Function,
      default: function _default() {
        return function () {};
      }
    },
    selectedId: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      name: '',
      comp: function comp() {
        return import('./flow-node');
      }
    };
  },
  computed: {
    labels: function labels() {
      var conditionList = this.sourceData.conditionList;
      var len = conditionList.length;
      return conditionList.map(function (item, index) {
        return handlerBranch(item, index, len);
      });
    }
  },
  inject: ['handlerSelected', 'handlerAddNode'],
  methods: {
    showData: showData,
    // 修改名称input展示
    handlerEdit: function handlerEdit(params, i) {
      if (params.isDefault) return false;
      this.name = params.nodeName;
      var el = this.$refs.inputs[i];
      var title = this.$refs.title[i];
      el.style.display = 'block';
      title.style.display = 'none';
      this.$nextTick(function () {
        el.select();
        el.focus();
      });
    },
    // 保存名称修改
    handlerSave: function handlerSave(item, i) {
      var el = this.$refs.inputs[i];
      var title = this.$refs.title[i];
      el.style.display = 'none';
      title.style.display = 'block';
      if (this.name) item.nodeName = this.name;
    },
    // 位移更改权重
    changePosition: function changePosition(i, n) {
      var conditionList = this.sourceData.conditionList;
      var data = conditionList[n];
      this.$set(conditionList, n, conditionList[i]);
      this.$set(conditionList, i, data);
    },
    /**
     *  @description 左右位移展示逻辑
     *  @param { Object } item 当前节点
     *  @param { Number } i 节点下标
     *  @returns { Array } 数组里边对应俩个值 类型为boolean  true或false
     */
    handlerIsArrow: function handlerIsArrow(i) {
      var length = this.sourceData.conditionList.length;
      // 节点数小于3个时或最后一个节点
      if (length < 3 || i === length - 1) return [false, false];
      var leftArrow = true,
        rightArrow = true;
      // 首个节点没有左移
      if (i < 1) leftArrow = false;
      if (i >= length - 2) rightArrow = false;
      return [leftArrow, rightArrow];
    }
  }
};